import { useState, useEffect } from 'react'
import { get } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { SoldServiceAppDataModel } from '@user/store/opportunity'

export const useGetSoldServicesAppDataOnMount = (
  branchId: string | undefined,
) => {
  type State = {
    status: 'pending' | 'success' | 'fail'
    appData: SoldServiceAppDataModel[]
  }
  const [state, setState] = useState<State>({
    appData: [],
    status: 'pending',
  })

  const baseUrl = `${ServiceConfig.baseAPIUrl}/branch/`

  useEffect(() => {
    if (!branchId) return

    let mounted = true

    const execute = async () => {
      try {
        const response = await get(
          `${baseUrl}${branchId}${ServiceConfig.branch.soldService.appData}`,
        )

        if (response.ok) {
          setState({ status: 'success', appData: await response.json() })
        } else {
          setState({ status: 'fail', appData: [] })
        }
      } catch (error) {
        if (mounted) {
          setState({ status: 'fail', appData: [] })
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [baseUrl, branchId])

  return { ...state } as const
}
